/**
 * Rich text editor used in the admin blog & resources pages.
 * Wraps react-quill-new with a clean violet theme and the imports we need.
 */
import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './rich-editor.css';

const TOOLBAR = [
  [{ header: [2, 3, 4, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['blockquote', 'code-block'],
  ['link', 'image'],
  [{ align: [] }],
  ['clean'],
];

const FORMATS = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'bullet',
  'blockquote', 'code-block',
  'link', 'image', 'align',
];

export default function RichTextEditor({ value, onChange, placeholder, className = '' }) {
  return (
    <div className={`admin-rich-editor ${className}`}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={{ toolbar: TOOLBAR }}
        formats={FORMATS}
        placeholder={placeholder || 'Write your post…'}
      />
    </div>
  );
}
